import type { ConfigurationResponse } from "@platform/api";

export const MISSING_TEMPLATE = "MISSING TEMPLATE";

/**
 * A configuration is identified in conversation by its name and the workbook it
 * exports with, so the list shows both — and says so loudly when no template is
 * set, since the configuration can't export without one.
 */
export const configurationLabel = (config: ConfigurationResponse): string =>
  `${config.name} - ${config.configuration?.template ?? MISSING_TEMPLATE}`;

/** Assigned broker names, alphabetical; unknown ids fall back to their number. */
export const brokerNamesFor = (
  config: ConfigurationResponse,
  brokerNamesById: Map<number, string>,
): string[] =>
  (config.brokerIds ?? [])
    .map((brokerId) => brokerNamesById.get(brokerId) ?? `Broker ${brokerId}`)
    .sort((a, b) => a.localeCompare(b));

/** Matches the search term against name, template name and broker names. */
export const filterConfigurations = (
  configurations: ConfigurationResponse[],
  search: string,
  brokerNamesById: Map<number, string>,
): ConfigurationResponse[] => {
  const term = search.trim().toLowerCase();
  if (!term) return configurations;

  return configurations.filter((config) =>
    [
      config.name,
      config.configuration?.template ?? MISSING_TEMPLATE,
      ...brokerNamesFor(config, brokerNamesById),
    ]
      .join(" ")
      .toLowerCase()
      .includes(term),
  );
};
